import { render, staticRenderFns } from "./MagicPricePoint.vue?vue&type=template&id=91d74d60"
import script from "./MagicPricePoint.vue?vue&type=script&lang=js"
export * from "./MagicPricePoint.vue?vue&type=script&lang=js"
import style0 from "./MagicPricePoint.vue?vue&type=style&index=0&id=91d74d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports